export const PROJECT_PERMISSIONS = [
	'ADMINISTER_PROJECTS',
	'EDIT_WORKFLOW',
	'EDIT_ISSUE_LAYOUT',
	'ADD_COMMENTS',
	'EDIT_OWN_COMMENTS',
	'EDIT_ALL_COMMENTS',
	'CREATE_ISSUES',
	'EDIT_ISSUES',
	'SCHEDULE_ISSUES',
	'DELETE_ISSUES',
	'CREATE_ATTACHMENTS',
	'DELETE_OWN_ATTACHMENTS',
	'DELETE_ALL_ATTACHMENTS',
	'LINK_ISSUES',
	'MOVE_ISSUES',

	'CREATE_DISCOVERY_INSIGHTS',
	'MANAGE_DISCOVERY_INSIGHTS',
	'MANAGE_DISCOVERY_DELIVERY',
	'MERGE_DISCOVERY_ISSUES',
	'ARCHIVE_DISCOVERY_ISSUES',
	'DISCOVERY_VOTE',
	'MANAGE_DISCOVERY_IDEA_TEMPLATES',

	'PIN_DISCOVERY_ISSUE_VIEW_FIELDS',
	'MANAGE_DISCOVERY_VIEWS',
	'SHARE_DISCOVERY_VIEWS',
	'PUBLISH_DISCOVERY_VIEWS',
	'CREATE_DISCOVERY_VIEW_COMMENTS',
	'MANAGE_DISCOVERY_VIEW_COMMENTS',

	'MANAGE_WATCHERS',
	'VIEW_VOTERS_AND_WATCHERS',
	'MODIFY_REPORTER',
	'PUBLISH_PUBLIC_DISCOVERY_VIEWS',
] as const;

export const GLOBAL_PERMISSIONS = ['BULK_CHANGE', 'CREATE_PROJECT'] as const;

export type SupportedPermissions =
	| (typeof PROJECT_PERMISSIONS)[number]
	| (typeof GLOBAL_PERMISSIONS)[number];
